module.exports = __webpack_public_path__ + "static/img/imginfo.8c405ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/imginfo.png
// module id = LZpZ
// module chunks = 51